import { useTranslation } from "react-i18next"
import { DropdownSelect } from "@/components/ui/dropdown-select"
import { INSURANCE_COUNTRIES } from "@/modules/admin/better-doc/constants/better-doc-constants"
import { getBetterDocEnumLabel } from "@/modules/admin/better-doc/lib/better-doc-enum-label"
import { findEnumValue } from "@/modules/admin/better-doc/lib/find-enum-value"
import { Country } from "@/types/__generated__/union-types"

type BetterDocInsuranceCountrySelectProps = {
  insuranceCountry: Country
  onInsuranceCountryChange: (insuranceCountry: Country) => void
  testId: string
}

export const BetterDocInsuranceCountrySelect = ({
  insuranceCountry,
  onInsuranceCountryChange,
  testId,
}: BetterDocInsuranceCountrySelectProps) => {
  const { t } = useTranslation()

  const countryOptions = INSURANCE_COUNTRIES.map((country) => ({
    value: country,
    label: getBetterDocEnumLabel(t, "insuranceCountry", country),
  }))

  const handleSelect = (selectedValue: string | null | undefined) => {
    const selectedCountry = findEnumValue(INSURANCE_COUNTRIES, selectedValue)
    if (selectedCountry !== null) {
      onInsuranceCountryChange(selectedCountry)
    }
  }

  return (
    <DropdownSelect
      label={t("admin.betterDoc.insuranceCountry.label")}
      options={countryOptions}
      defaultValue={insuranceCountry}
      onSelect={handleSelect}
      className="w-56"
      testId={testId}
    />
  )
}
